var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCirculoPerfil(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "203px",
    height: "203px",
    viewBox: "0 0 203 203",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Grupo 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 82,
    cy: 82,
    r: 82
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "PANTALLAS-ESCAPE",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "SUPERTEST.-PANTALLA-RESULTADOS---Pantalla-gen\\xE9rica--",
    transform: "translate(-113, -323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo-1",
    transform: "translate(113, 323)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#690ED1",
    strokeWidth: 4,
    cx: 101.5,
    cy: 101.5,
    r: 99.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#001A72",
    cx: 101.5,
    cy: 101.5,
    r: 93.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "grupo-3",
    transform: "translate(20, 20)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCirculoPerfil);
export default __webpack_public_path__ + "static/media/circulo-perfil.f122aaa25c9c8ed9463b51f9a263019e.svg";
export { ForwardRef as ReactComponent };